import { useTheme } from 'styled-components'

import { Plus } from '@corabank/icons'

import { EmptyFileProps } from './interface'
import * as Styled from './styles'

const EmptyFile = ({ dragAccept, children }: EmptyFileProps): JSX.Element => {
  const theme = useTheme()

  return (
    <Styled.FileUpload dragAccept={dragAccept}>
      <Styled.FileUploadLeft>
        <Styled.FileUploadIcon backgroundColor={theme.colors.mainPrimary}>
          <Plus color={theme.colors.graysWhite} />
        </Styled.FileUploadIcon>
        <Styled.FileUploadText>
          {dragAccept
            ? 'Solte o arquivo para adicioná-lo'
            : 'Clique ou arraste para adicionar o arquivo'}
        </Styled.FileUploadText>
      </Styled.FileUploadLeft>
      {children}
    </Styled.FileUpload>
  )
}

export { EmptyFile }
